import type { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { TextUnderCardProps } from './types';
import {
  TextUnderCardWrapper, StyledText, StyledPrice, StyledNoListings,
  ForSaleWrapper, ListingWrapper,
} from './styled';

const TextUnderCard: FC<TextUnderCardProps> = ({
  listing,
  price = 0,
  listingsCount = 0,
  isCollectedCollection,
  forSale,
  isStaked,
}) => {
  const { t } = useTranslation();

  let collectedCardText: ReactElement | null = null;
  if (isCollectedCollection) {
    if (forSale) {
      if (listing) {
        collectedCardText = (
          <ListingWrapper>
            <StyledText size="captionSmall" textColor="textWhite" lSpacing={1}>
              Lowest Price
            </StyledText>
            <StyledPrice size="title" textColor="textWhite" bold lSpacing={1}>
              $
              {price.toFixed(2)}
            </StyledPrice>
          </ListingWrapper>
        );
      } else {
        collectedCardText = (
          <>
            <ForSaleWrapper>
              {t('card.forSale')}
            </ForSaleWrapper>
            <StyledPrice size="title" textColor="textWhite" bold lSpacing={1}>
              $
              {price.toFixed(2)}
            </StyledPrice>
          </>
        );
      }
    } else {
      collectedCardText = (
        <StyledNoListings size="title" textColor="lightGray" lSpacing={1}>
          {t('card.notForSale')}
        </StyledNoListings>
      );
    }
    if (isStaked) {
      collectedCardText = (
        <StyledNoListings size="title" textColor="lightGray" lSpacing={1}>
          Staked
        </StyledNoListings>
      );
    }
  }

  return (
    <TextUnderCardWrapper data-test-id="text_under_card">
      {
        isCollectedCollection ? collectedCardText : (
          <>
            {listing
              ? (
                <ListingWrapper>
                  <StyledText size="captionSmall" textColor="textWhite" lSpacing={1}>
                    {t('card.lowestAsk')}
                  </StyledText>
                  <StyledPrice size="title" textColor="textWhite" bold lSpacing={1}>
                    $
                    {price.toFixed(2)}
                  </StyledPrice>
                  <StyledText size="unmedia16" textColor="lightGray" lSpacing={1}>
                    {t('card.listings', { amount: listingsCount })}
                  </StyledText>
                </ListingWrapper>
              ) : (
                <StyledNoListings size="title" textColor="lightGray" lSpacing={1}>
                  {t('card.noListings')}
                </StyledNoListings>
              )}
          </>
        )
      }
    </TextUnderCardWrapper>
  );
};

export default TextUnderCard;
